<script lang="ts">
	import Map from "../components/map/Map.svelte";
	import { appManager } from "../AppManager";
	import { _ } from "svelte-i18n";
	import ZoomControl from "../components/map/zoom/ZoomControl.svelte";
	import { ModelViewManager } from "./ModelViewManager";
	import LayersControl from "./layers/LayersControl.svelte";
	import SearchControl from "../components/search/SearchControl.svelte";
	import ModelInfo from "./info/ModelInfo.svelte";
	import ForkToProjectControl from "./fork/ForkToProjectControl.svelte";
    import FullScreenAlertOverlay from "../components/alerts/FullScreenAlertOverlay.svelte";
    import ModelLocationInfo from "./location_info/ModelLocationInfo.svelte";
    import ModelSegmentInfo from "./segment_info/ModelSegmentInfo.svelte";

	export let modelGlobalId: string;

	const manager = new ModelViewManager();
	let modelTranslationKeyStore = manager.getModelTranslationKeyStore();

	$: if (typeof modelGlobalId !== "undefined") {
		manager.initialize(modelGlobalId);
	}
</script>

<svelte:head>
	<title
		>{$_("title")} |  {$_(
			`subtitle`,
		)} | {$_(
			`${$modelTranslationKeyStore}.page.subtitle`,
		)}</title>
</svelte:head>

<div class="full">
	<FullScreenAlertOverlay {manager}/>
	<div id="content" class="container-fluid mx-0 px-0">
		<div class="row h-100">
			<div class="container-map">
				<Map manager={manager.getMapManager()}>
					<ZoomControl manager={manager.getMapManager()} />
					<LayersControl
						manager={manager.getLayersControlManager()} />
					<SearchControl
						manager={manager.getSearchControlManager()} />

					<ModelInfo manager={manager.getModelInfoManager()} />
					<ModelLocationInfo manager={manager.getModelLocationInfoManager()} />
					<ModelSegmentInfo manager={manager.getModelSegmentInfoManager()} />
					<ForkToProjectControl {manager} />
				</Map>
			</div>
		</div>
	</div>
</div>